import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import ItemSender from "./ItemSender";
import "./item.css";
import Container from "@material-ui/core/Container";
import CustomizedProgressBars from "./spinner";
import * as ACTION from "../Actions/main";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  overrides: {
    MuiTypography: {
      root: {
        fontSize: "14px !important",
        padding: "0px !important"
      }
    },
    MuiOutlinedInput: {
      root: {
        fontSize: "14px !important"
      },
      input: {
        padding: "10px"
      }
    }
  }
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

// const classes = useStyles();
// const [value, setValue] = React.useState(0);

class Tabcha extends Component {
  state = { value: 0, isSpinner: false };

  handleChange = (event, newValue) => {
    console.log("dumb");

    this.setState({ value: newValue, isSpinner: true }, () => {
      console.log(this.state);
    });

    console.log(newValue);

    setTimeout(() => {
      this.setState(
        {
          isSpinner: false
        },
        () => {
          console.log(this.state);
        }
      );
    }, 600);
  };

  render() {
    const t = this.props.EachCat.map(e => {
      return <Tab label={e} key={e} />;
    });

    return this.state.isSpinner === false ? (
      <MuiThemeProvider theme={theme}>
        {" "}
        <div>
          <AppBar
            style={{
              position: "fixed",
              top: 106,
              zIndex: 100,
              width: "100%"
            }}
            color="default"
          >
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="on"
            >
              {t}
            </Tabs>
          </AppBar>
          {this.props.EachCat.map((e, index) => {
            return (
              <Fragment key={e}>
                {this.state.value === index && (
                  <TabContainer>
                    <ItemSender cat={e} />
                  </TabContainer>
                )}
              </Fragment>
            );
          })}
        </div>{" "}
      </MuiThemeProvider>
    ) : (
      <Container>
        {console.log("inside spinner")}
        {/* <Typography
          variant="h5"
          color="textSecondary"
          align="center"
          style={{ marginBottom: 155 }}
        >
          Menu is Loading
        </Typography> */}
        <div style={{ textAlign: "center", marginTop: 205 }}>
          <CustomizedProgressBars />
        </div>
      </Container>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    toggelLoading: bool => dispatch(ACTION.toggelLoading(bool))
  };
};

const mapStateToProps = state => {
  return {
    EachCat: state.menuR.EachCat
    // isLoading: state.menuR.isLoading
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Tabcha);
